/**
 * Central de manuais — busca, tabs de categoria e ordenação.
 * Prévia/tamanho: delegados a <igf-docs> (assets/igf-docs.js).
 */
class IgfCentralManuais extends HTMLElement {
  #ready = false;

  connectedCallback() {
    if (this.#ready) return;
    this.#ready = true;

    this.form = this.querySelector('[data-igf-cm-search-form]');
    this.input = this.querySelector('[data-igf-cm-search-input]');
    this.tabs = this.querySelector('[data-igf-cm-tabs]');
    this.sort = this.querySelector('[data-igf-cm-sort]');
    this.grid = this.querySelector('[data-igf-cm-grid]');
    this.empty = this.querySelector('[data-igf-cm-empty]');
    this.chips = this.querySelectorAll('[data-igf-cm-chip]');

    this.category = 'all';
    this.query = '';

    this.#bind();
    this.#apply();
  }

  #bind() {
    this.form?.addEventListener('submit', (event) => {
      event.preventDefault();
      this.query = (this.input?.value || '').trim().toLowerCase();
      this.#apply();
    });

    this.input?.addEventListener('input', () => {
      this.query = (this.input.value || '').trim().toLowerCase();
      this.#apply();
    });

    this.tabs?.addEventListener('click', (event) => {
      const button = event.target.closest('[data-igf-cm-tab]');
      if (!button || !this.tabs.contains(button)) return;

      this.category = button.getAttribute('data-igf-cm-tab') || 'all';
      this.tabs.querySelectorAll('[data-igf-cm-tab]').forEach((tab) => {
        const active = tab === button;
        tab.setAttribute('aria-pressed', active ? 'true' : 'false');
        tab.classList.toggle('is-active', active);
      });
      this.#apply();
    });

    this.sort?.addEventListener('change', () => {
      this.#apply();
    });

    for (const chip of this.chips) {
      chip.addEventListener('click', () => {
        const value = chip.getAttribute('data-igf-cm-chip') || '';
        if (this.input) this.input.value = value;
        this.query = value.trim().toLowerCase();
        this.#apply();
      });
    }
  }

  #cards() {
    return Array.from(this.querySelectorAll('[data-igf-cm-card]'));
  }

  #matches(card) {
    const category = (card.getAttribute('data-category') || '').toLowerCase();
    const search = (card.getAttribute('data-search') || '').toLowerCase();

    if (this.category !== 'all' && category !== this.category) return false;
    if (this.query && !search.includes(this.query)) return false;
    return true;
  }

  #sortCards(cards) {
    const mode = this.sort?.value || 'recent';
    const sorted = [...cards];

    sorted.sort((a, b) => {
      if (mode === 'az') {
        return (a.getAttribute('data-title') || '').localeCompare(b.getAttribute('data-title') || '', 'pt', {
          sensitivity: 'base',
        });
      }
      if (mode === 'za') {
        return (b.getAttribute('data-title') || '').localeCompare(a.getAttribute('data-title') || '', 'pt', {
          sensitivity: 'base',
        });
      }
      const aTime = Number(a.getAttribute('data-updated') || 0);
      const bTime = Number(b.getAttribute('data-updated') || 0);
      return bTime - aTime;
    });

    return sorted;
  }

  #apply() {
    if (!this.grid) return;

    const cards = this.#cards();
    const visible = [];

    for (const card of cards) {
      const show = this.#matches(card);
      card.hidden = !show;
      if (show) visible.push(card);
    }

    const ordered = this.#sortCards(visible);
    for (const card of ordered) {
      this.grid.append(card);
    }

    if (this.empty) {
      this.empty.hidden = visible.length > 0;
    }

    this.#updateTabCounts(cards);
  }

  #updateTabCounts(cards) {
    if (!this.tabs) return;

    const counts = { all: cards.length };

    for (const card of cards) {
      const category = (card.getAttribute('data-category') || '').toLowerCase();
      if (!category) continue;
      counts[category] = (counts[category] || 0) + 1;
    }

    this.tabs.querySelectorAll('[data-igf-cm-tab]').forEach((tab) => {
      const key = tab.getAttribute('data-igf-cm-tab') || 'all';
      const countNode = tab.querySelector('[data-igf-cm-tab-count]');
      if (countNode) countNode.textContent = String(counts[key] || 0);
    });
  }
}

if (!customElements.get('igf-central-manuais')) {
  customElements.define('igf-central-manuais', IgfCentralManuais);
}
